import React from "react";
import {useTableDetail} from "../../../../../common/API/hooks";
import Select from 'react-select'
import {getSelectedOption} from "../../../../../common/utils";
import ColumnOption from "./ColumnOption";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from '@mui/material/CircularProgress';


export default function ValueSelector({setChartData, chartData}) {
    // this is a more intelligent selector

    const {data: tableData, isLoading: isLoadingFilters} = useTableDetail(chartData.table_source, {
        enabled: !!chartData.table_source
    })

    const columnOptions = tableData?.columns.filter(column => {
        return column.json_type === 'number' || column.json_type === 'integer'
    }).map(column => {
        return {
            label: column.name,
            value: column.name,
            get_param: "columns",
            json_type: column.json_type
        }
    })

    // get aggregates that are numeric
    const aggregateOptions = tableData?.aggregates.filter(agg => {
        return agg.is_numeric
    }).map(agg => {
        return {
            label: agg.name,
            value: agg.name,
            get_param: "aggregates",
            json_type: agg.json_type
        }
    })

    const options = [...(columnOptions || []), ...(aggregateOptions || [])].sort((a, b) => {
        return a.label.localeCompare(b.label)
    })

    return <Grid item md={12} marginBottom={2}>
        <Autocomplete
            disableClearable
            value={chartData.extra_data.value}
            onChange={(event,onChangeValue) => {
                if (!onChangeValue) {
                    setChartData(prevState => {
                        return {
                            ...prevState,
                            extra_data: {
                                ...prevState.extra_data,
                                value: null
                            }
                        }
                    })
                } else {
                    setChartData(prevState => {
                        return {
                            ...prevState,
                            extra_data: {
                                ...prevState.extra_data,
                                value: onChangeValue
                            }
                        }
                    })
                }
            }}
            id="value_options" size="small"
            options={options|| []}
            getOptionLabel={(option) => option?.label || ""}
            disabled={isLoadingFilters || !chartData.table_source}
            loading={isLoadingFilters}
            sx={{ width: "100%" }}
            // TODO: RENDER OPTION, COLUMNOPTION
            renderInput={(params) => <TextField {...params} label="Value"
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                    <React.Fragment>
                        {isLoadingFilters ? <CircularProgress color="secondary" size={20} /> : null}
                        {params.InputProps.endAdornment}
                    </React.Fragment>
                    ),
                }}
                required/>
            }
        />
    </Grid>
}